<div class="row" *ngIf="isComercial || isBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <!-- Inicio Linha 1 -->

          <div class="row pt-3">
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Grãos Ardidos - MILHO (g)</mat-label>
                <input matInput id="txtGraosArdidos" #txtGraosArdidos maxlength="9" formControlName="Graos_Ardidos"
                  currencyMask (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtGraosArdidos.value.length}} / 9</mat-hint>
                <mat-error *ngIf="formulario.get('Graos_Ardidos').hasError('max')">O valor máximo é 20.000.</mat-error>
                <mat-error>{{ hasErrorFormControl(formulario.controls.Graos_Ardidos) }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}"
                [ngClass]='{"mat-form-field-invalid": formulario.controls.Sabugo.warning}'>
                <mat-label class="InputLabelColor">Sabugo - MILHO (g)</mat-label>
                <input matInput id="txtSabugoMilho" #txtSabugoMilho maxlength="9" formControlName="Sabugo" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="getQtdeSabugoMi()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtSabugoMilho.value.length}} / 9</mat-hint>
                <mat-error *ngIf="formulario.get('Sabugo').hasError('max')">O valor máximo é 20.000.</mat-error>
                <mat-error>{{ hasErrorFormControl(formulario.controls.Sabugo) }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Grãos Carunchados/Furados - MILHO (g)
                </mat-label>
                <input matInput id="txtGraosCarunchados" #txtGraosCarunchados maxlength="9"
                  formControlName="Graos_Carunchados" currencyMask (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtGraosCarunchados.value.length}} / 9</mat-hint>
                <mat-error *ngIf="formulario.get('Graos_Carunchados').hasError('max')">O valor máximo é 20.000.</mat-error>
                <mat-error>{{ hasErrorFormControl(formulario.controls.Graos_Carunchados) }}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 1 -->

          <!-- Inicio Linha 2 -->

          <div class="row pt-3">
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Sementes Quebradas - MILHO (g)</mat-label>
                <input matInput id="txtSemQuebradas" #txtSemQuebradas maxlength="9" formControlName="Sementes_Quebradas"
                  currencyMask (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtSemQuebradas.value.length}} / 9</mat-hint>
                <mat-error *ngIf="formulario.get('Sementes_Quebradas').hasError('max')">O valor máximo é 20.000.</mat-error>
                <mat-error>{{ hasErrorFormControl(formulario.controls.Sementes_Quebradas) }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Out Cultivares [tigue, macho, hy] - MILHO (g)
                </mat-label>
                <input matInput id="txtOutCultivares" #txtOutCultivares maxlength="9" formControlName="Out_Cultivares"
                  currencyMask (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtOutCultivares.value.length}} / 9</mat-hint>
                <mat-error *ngIf="formulario.get('Out_Cultivares').hasError('max')">O valor máximo é 20.000.</mat-error>
                <mat-error>{{ hasErrorFormControl(formulario.controls.Out_Cultivares) }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Observação</mat-label>
                <textarea class="start-height" matInput id="txtObs" #txtObs maxlength="255" formControlName="Observacao"
                  (blur)="makeCalculations()"></textarea>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Observacao)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 2 -->

        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>
<div class="row" *ngIf="isPreBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <!-- Inicio Linha 1 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso da amostra (kg)
                </mat-label>
                <input matInput id="txtPesoAmostra" #txtPesoAmostra maxlength="10" formControlName="peso_amostra"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculationsPreBasica($event)">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoAmostra.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_amostra)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso líquido da carga (kg)</mat-label>
                <input matInput id="txtPesoLiquidoCarga" #txtPesoLiquidoCarga maxlength="10"
                  formControlName="peso_liquido" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculationsPreBasica($event)">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoLiquidoCarga.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_liquido)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso da palha (kg)</mat-label>
                <input matInput id="txtPesoPalha" #txtPesoPalha maxlength="10" formControlName="palha" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculationsPreBasica($event)">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoPalha.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.palha)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso de impurezas (kg)</mat-label>
                <input matInput id="txtPesoImpurezas" #txtPesoImpurezas maxlength="10" formControlName="impurezas"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculationsPreBasica($event)">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoImpurezas.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.impurezas)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 1 -->

          <!-- Inicio Linha 2 -->

          <div class="row pt-3">
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso de sementes (kg)</mat-label>
                <input matInput id="txtPesoSementes" #txtPesoSementes maxlength="10" formControlName="peso_sementes"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculationsPreBasica($event)">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoSementes.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_sementes)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso de material ardido (kg)</mat-label>
                <input matInput id="txtPesoMaterialArdido" #txtPesoMaterialArdido maxlength="10"
                  formControlName="peso_material" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculationsPreBasica($event)">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoMaterialArdido.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_material)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso do sabugo - MILHO (g)</mat-label>
                <input matInput id="txtPesoSabugoMilho" #txtPesoSabugoMilho maxlength="10" formControlName="sabugo_milho"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" (blur)="makeCalculationsPreBasica($event)">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtPesoSabugoMilho.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.sabugo_milho)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Espigas atípicas (g)</mat-label>
                <input matInput id="txtEspigasAtipicas" #txtEspigasAtipicas maxlength="10"
                  formControlName="espigas_atipicas" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtEspigasAtipicas.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.espigas_atipicas)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Descarte em mesa</mat-label>
                <input matInput id="txtDescarteMesa" #txtDescarteMesa maxlength="10" formControlName="descarte_mesa"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtDescarteMesa.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.descarte_mesa)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Fim Linha 2 -->
          <div class="row pt-3">

            <div class="col-md">
              <mat-form-field class="wd-100-pc" appearance="{{formFieldAppearance}}"
                floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Observação</mat-label>
                <textarea class="start-height" matInput id="txtObs" #txtObs maxlength="255" formControlName="observacao_amostra"
                  (blur)="makeCalculations()"></textarea>
                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                <mat-hint align="end">{{txtObs.value.length}} / 255</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.observacao_amostra)}}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>